import { FeatureFlagTypes, Permissions } from '@raptor-fe/core';
import { NamedRoutes } from '@raptor-fe/services';
import { MenuItem } from '@raptor-fe/ui';

export const menuContents: MenuItem[] = [
    { text: 'Home', iconClass: 'bi-house fs-3', route: NamedRoutes.home().path },
    {
        text: 'Dashboard',
        iconClass: 'bi-graph-up fs-3',
        route: NamedRoutes.dashboard().path,
        features: [FeatureFlagTypes.DigitalVehicleInspection],
    },
    { text: 'Customers', iconClass: 'bi-person-fill fs-3', route: NamedRoutes.customerList().path, viewPermission: Permissions.Customer.View },
    {
        text: 'Appointments',
        iconClass: 'bi-calendar-check fs-3',
        features: [FeatureFlagTypes.CheckIn, FeatureFlagTypes.SelfCheckIn],
        children: [
            {
                text: 'Completed Appointments',
                route: NamedRoutes.completedAppointmentList().path,
                features: [FeatureFlagTypes.CheckIn],
            },
            {
                text: 'Self Check-Ins',
                route: NamedRoutes.selfCheckInAdminList().path,
                viewPermission: Permissions.Appointment.View,
                features: [FeatureFlagTypes.SelfCheckIn],
            },
        ],
    },
    {
        text: 'DVI',
        iconClass: 'bi-clipboard fs-3',
        features: [FeatureFlagTypes.DigitalVehicleInspection],
        children: [
            { text: 'Inspections', route: NamedRoutes.inspectionList().path, viewPermission: Permissions.Inspection.View },
            {
                text: 'Templates',
                route: NamedRoutes.inspectionTemplateList().path,
                viewPermission: Permissions.InspectionTemplate.View,
            },
            {
                text: 'Skip Reasons',
                route: NamedRoutes.skipReasonList().path,
                viewPermission: Permissions.InspectionTemplate.Update,
                features: [FeatureFlagTypes.SkipInspection],
            },
        ],
    },
    { text: 'User Device', iconClass: 'bi-phone fs-3', route: NamedRoutes.userDevice({}).path, viewPermission: Permissions.UserDevice.Manage },
    {
        text: 'Time Clock',
        iconClass: 'bi-clock-history fs-3',
        route: NamedRoutes.timeClockList().path,
        viewPermission: Permissions.TimeClock.View,
        features: [FeatureFlagTypes.TimeClock],
    },
    {
        text: 'Work Orders',
        iconClass: 'bi-file-earmark-text fs-3',
        route: NamedRoutes.workOrderList().path,
        viewPermission: Permissions.WorkOrder.View,
        features: [FeatureFlagTypes.WorkOrder],
    },
    {
        text: 'Settings',
        iconClass: 'bi-gear fs-3',
        children: [
            {
                text: 'Appointments',
                viewPermission: Permissions.Appointment.View,
                features: [FeatureFlagTypes.CheckIn, FeatureFlagTypes.SelfCheckIn],
                children: [
                    {
                        text: 'Appointment Add-Ons',
                        route: NamedRoutes.appointmentAddOnList().path,
                        viewPermission: [Permissions.Addon.Create, Permissions.Addon.Update, Permissions.Addon.Delete],
                        features: [FeatureFlagTypes.CheckIn],
                    },
                    {
                        text: 'Pickup Options',
                        route: NamedRoutes.pickupOptionList().path,
                        viewPermission: Permissions.Appointment.ManagePickupOptions,
                        features: [FeatureFlagTypes.CheckIn],
                    },
                    /**
                     * Agreements is conceptually a general-purpose config item, but today it is used
                     * only in the appointment flow, so it is grouped under Appointments. Relocate it
                     * to a more general Settings group if it later becomes non-appointment-specific.
                     */
                    { text: 'Agreements', route: NamedRoutes.agreementList().path, viewPermission: Permissions.Agreement.View },
                    {
                        text: 'Self Check-in',
                        route: NamedRoutes.selfCheckInSettings().path,
                        viewPermission: Permissions.Appointment.ManageSelfCheckInFields,
                        features: [FeatureFlagTypes.SelfCheckIn],
                    },
                ],
            },
            { text: 'Announcements', route: NamedRoutes.systemAnnouncementList().path, viewPermission: Permissions.Announcement.Manage },
            {
                text: 'Audit Log',
                route: NamedRoutes.auditLogList().path,
                viewPermission: Permissions.Audit.View,
                features: [FeatureFlagTypes.AuditLog],
            },
            { text: 'System Settings', route: NamedRoutes.systemSettings().path, viewPermission: Permissions.Settings.Manage },
            {
                text: 'Customer Report Messages',
                route: NamedRoutes.customerReportMessages().path,
                viewPermission: Permissions.Settings.Manage,
                features: [FeatureFlagTypes.DigitalVehicleInspection],
            },
            { text: 'Tenant', route: NamedRoutes.tenantList().path, viewPermission: Permissions.Tenant.List },
            { text: 'My Tenant', route: NamedRoutes.myTenant().path, viewPermission: Permissions.Tenant.Read },
            { text: 'Theme Management', route: NamedRoutes.themeManagement().path, viewPermission: Permissions.Branding.View },
            { text: 'User', route: NamedRoutes.userList().path, viewPermission: Permissions.User.View },
            { text: 'Wording', route: NamedRoutes.translationManagement().path, viewPermission: Permissions.Translation.Manage },
            { text: 'Roles', route: NamedRoutes.roleManagement().path, viewPermission: Permissions.Role.View },
            { text: 'Branches', route: NamedRoutes.branchList().path, viewPermission: Permissions.Branch.View },
            { text: 'Device Allowlist', route: NamedRoutes.deviceAllowlistList().path, viewPermission: Permissions.TenantDevice.Manage },
            { text: 'Job Categories', route: NamedRoutes.jobCategoryList().path, viewPermission: Permissions.JobCategory.View },
        ],
    },
];
